import { useTranslation } from 'react-i18next';

import { SummaryBox } from '@app/dashboard/components/inner_layout/Cards/SummaryBox';
import { EMPTY_VALUE } from '@app/dashboard/constants/shared';

import { getTenure } from '../../utils';

const InstallmentInfo = ({
  installmentInfo,
}: {
  installmentInfo: {
    finance_amount: number;
    tenure: number;
    discount_amount: number;
    down_payment: number;
    cashback_amount: number;
    administrative_fees: number;
  };
}) => {
  const { t } = useTranslation();

  const pairsList = [
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.financeAmount'),
      value: installmentInfo.finance_amount || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.installmentPlan'),
      value: getTenure(installmentInfo.tenure) || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.discountAmount'),
      value: installmentInfo.discount_amount || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.downPayment'),
      value: installmentInfo.down_payment || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.cashback'),
      value: installmentInfo.cashback_amount || EMPTY_VALUE,
    },
    {
      label: t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.administrativeFees'),
      value: installmentInfo.administrative_fees || EMPTY_VALUE,
    },
  ];

  return (
    <SummaryBox
      title={t('innerLayout.transactionsPage.singleTransactionsPage.detailsBoxes.installmentInfo.title')}
      itemsList={pairsList}
    />
  );
};

export default InstallmentInfo;
